<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" />
    <tag-view />
    <div class="main-container">
      <app-main />
      <div class="logout-container">
        <span>{{ userName }}</span>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            <img src="../assets/images/login/logout.png" alt="">
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
            <el-dropdown-item command="modifyPass">修改密码</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { Sidebar, AppMain, TagView } from './components';
import ResizeMixin from './mixin/ResizeHandler';
import { logout, userLogout } from '@/api/login';

export default {
  name: 'Layout',
  components: {
    Sidebar,
    AppMain,
    TagView,
  },
  mixins: [ResizeMixin],
  data() {
    return {
      userName: '',
    };
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        'hide-sidebar': !this.sidebar.opened,
        'open-sidebar': this.sidebar.opened,
        'without-animation': this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile',
      };
    },
  },
  methods: {
    handleCommand(command) {
      if (command === "loginOut") {
        this.doLogOut();
      } else if (command === "modifyPass") {
        this.goModifyPwd();
      }
    },
    async doLogOut() {
      const result = await this.userLogout() && await this.logout();
      if (result) {
        window.localStorage.clear();
        this.$router.push({ path: '/login' });
      } else {
        this.$message.error('登出失败，请重试！');
      }
    },
    userLogout() {
      const loginInfo = window.localStorage.getItem('LOGIN_INFO') ? JSON.parse(window.localStorage.getItem('LOGIN_INFO')) : {};
      const sessionId = loginInfo.sessionId || '';
      // 缓存被清空，可直接退出
      if (!sessionId) {
        return true;
      }
      return new Promise((resolve, reject) => {
        userLogout({
          uatk: sessionId,
        }).then((res) => {
          // 10042 用户未登录或者登录态过期后调用此接口，等同于成功
          resolve([0, 10042].includes(res.data.code));
        }).catch((e) => {
          reject(e);
        });
      });
    },
    logout() {
      const userName = JSON.parse(window.localStorage.getItem('LOGIN_INFO')).userName;
      const sessionId = JSON.parse(window.localStorage.getItem('LOGIN_INFO')).sessionId;
      // 缓存被清空，可直接退出
      if (!sessionId || !userName) {
        return true;
      }
      return new Promise((resolve, reject) => {
        logout({
          userName,
          sessionId,
        }).then((res) => {
          resolve(res.data.error_code === 0);
        }).catch((e) => {
          reject(e);
        });
      });
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
    },
    goModifyPwd() {
      this.$router.push({ path: '/modifyPwd' });
    },
  },
  created() {
    if (JSON.parse(window.localStorage.getItem('LOGIN_INFO'))) {
      const { userRole } = JSON.parse(window.localStorage.getItem('LOGIN_INFO'));
      if (userRole === 1) {
        this.userName = JSON.parse(window.localStorage.getItem('LOGIN_INFO')).merchantName;
      } else {
        this.userName = JSON.parse(window.localStorage.getItem('LOGIN_INFO')).userName;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/mixin";
@import "../styles/variables";

.main-container {
  height: calc(100vh - 40px);
  overflow: auto;

  .logout-container {
    position: absolute;
    top: 30px;
    right: 50px;
    display: flex;
    align-items: center;

    img {
      padding-left: 20px;
      cursor: pointer;
    }
  }
}

.app-wrapper {
  @include clearfix;

  position: relative;
  min-width: 100vh;
  height: 100%;

  &.mobile.open-sidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  position: absolute;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.3;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hide-sidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
